<template>
  <v-container class="main-container responsive-height">
    <v-row dense>
      <v-col cols="12" md="3">
        <TitleCard></TitleCard>
        <v-row dense>
          <v-col cols="12" v-for="item in forecast" :key="item.day">
            <v-card
              outlined
              tile
              :to="item.links"
              :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'"
              class="widgets-card"
            >
              <v-btn
                class="mx-2 mb-3"
                fab
                link
                small
                elevation="0"
                :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F8F6FC'"
              >
                <v-icon color="greenMain">
                  {{ item.icon }}
                </v-icon>
              </v-btn>
              <p class="mb-0">{{ item.day }}</p>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="5">
        <BalanceCard></BalanceCard>
      </v-col>
      <v-col cols="12" md="4">
        <BalanceCardOthers></BalanceCardOthers>
      </v-col>
    </v-row>
   
    <v-row>
      <v-col cols="12">
        <MiddleBar></MiddleBar>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" class="position-relative">
        <ManageInvestorAccountDetailsAllTabs></ManageInvestorAccountDetailsAllTabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BalanceCard from "@/components/PagesComponents/ManageInvestorsAccountDetailsPage/BalanceCard.vue";
import BalanceCardOthers from "@/components/PagesComponents/ManageInvestorsAccountDetailsPage/BalanceCardOthers.vue";
import ManageInvestorAccountDetailsAllTabs from "@/components/PagesComponents/ManageInvestorsAccountDetailsPage/ManageInvestorAccountDetailsAllTabs.vue";
import MiddleBar from "@/components/PagesComponents/ManageInvestorsAccountDetailsPage/MiddleBar.vue";
import TitleCard from "@/components/PagesComponents/ManageInvestorsAccountDetailsPage/TitleCard.vue";
export default {
  data: () => ({
    forecast: [
      {
        day: "Change Password",
        icon: "mdi-lock-open-outline",
        links: "/change-mt5-password",
      },
    ],
  }),
  components: {
    BalanceCard,
    BalanceCardOthers,
    TitleCard,
    MiddleBar,
    ManageInvestorAccountDetailsAllTabs,
  },
};
</script>
